export default __webpack_public_path__ + "static/media/databutton.4d0cad71.png";